module.exports = __webpack_public_path__ + "static/img/quanmin_ydh1.e913fa14.png";